<script>
    import {onMount} from 'svelte'

    let visbile = false;
    
    onMount(()=>{
        function checkConnectivity(){
            visbile = !visbile;
            if(!visbile){
                location.reload()
            }
        }
        window.addEventListener('online',checkConnectivity)
        window.addEventListener('offline',checkConnectivity)
    })    
    
</script>
{#if visbile}
    <h1 class="bg-gray-900 text-white p-4 text-center">YOU MAY BE OFFLINE</h1>
{/if}